import { createDefaultHeaders } from 'owa-service/lib/createDefaultHeader';
import { getUserCulture } from 'owa-session-store';
import { userDate } from 'owa-datetime/lib';
import {
    ACCEPT_LANGUAGE,
    CLIENT_SESSION_ID,
    CLIENT_SESSION_LOCAL_TIME,
    GRIFFIN_VERSION,
} from '../../utils/constants';

interface PromiseWithBestEffort<T> extends Promise<T> {
    bestEffort?: T;
}

/**
 * Helper function to create 3S Query request headers
 */
export function createSubstrateSearchQueryHeaders(
    searchSessionId: string,
    customHeaders?: { [key: string]: string }
): PromiseWithBestEffort<{ [key: string]: string }> {
    const headers = createDefaultHeaders();

    // Add custom headers.
    headers[CLIENT_SESSION_ID] = searchSessionId;
    headers[CLIENT_SESSION_LOCAL_TIME] = userDate().toString();
    headers[GRIFFIN_VERSION] = 'GWSv2';
    headers[ACCEPT_LANGUAGE] = getUserCulture();

    if (customHeaders) {
        Object.keys(customHeaders).forEach(headerName => {
            headers[headerName] = customHeaders[headerName];
        });
    }

    return headers;
}
